























import { ref, defineComponent } from '@nuxtjs/composition-api';
import { Logger } from '@vue-storefront/core';
import Button from '~/components/atoms/Buttons/Button/Button.vue';

export default defineComponent({
  name: 'ShareUrl',
  components: {
    Button,
  },
  setup() {
    const isBoxVisible = ref(false);
    const toggleBoxVisibility = async () => {
      isBoxVisible.value = !isBoxVisible.value;
      try {
        await navigator.clipboard.writeText(window.location.href);
      } catch (err) {
        Logger.error('Failed to copy: ', err);
      }
      if (isBoxVisible.value) {
        setTimeout(() => {
          isBoxVisible.value = false;
        }, 2000);
      }
    };
    return {
      isBoxVisible,
      toggleBoxVisibility,
    };
  },
});
